import React, { useEffect, useState } from 'react';
import images from '../assets/images';
import CreatePostModal from '../components/modals/CreatePostModal';
import { InterestsModalWithImg } from '../components/modals/InterestsModalWithImg';
import { useRequest } from '../hooks/useRequest';
import { AiOutlineHeart, AiFillHeart } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import InfinitScroll from 'react-infinite-scroll-component';
import Slider from 'react-slick';
import Undertaking from './Undertaking';
import Cookies from 'universal-cookie';
import { setUserToStorage } from '../utils/Auth';
import { useGeneralDispatch, useGeneralState } from '../context/general/generalContext';
import { INTERESTS_MODAL } from '../context/general/constants';
import { BsPlusLg } from 'react-icons/bs';
import { MdOutlineArrowBack } from 'react-icons/md';
import Video from '../components/elements/Video';
const Home = () => {
  const dispatch = useGeneralDispatch();
  const { interestsModal } = useGeneralState();
  const [getCategories, setGetCategories] = useState([]);
  const [subCategories, setSubCategories] = useState({ open: false, items: [] });
  const [getFeed, setGetFeed] = useState([]);
  const [hasNext, setHasNext] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [categoryFilter, setCategoryFilter] = useState(null);
  const [subCategoryFilter, setSubCategoryFilter] = useState(null);
  const [page, setPage] = useState(0);
  //const [like, setLike] = useState("trial");
  const [likeCount, setLikeCount] = useState([]);
  const navigate = useNavigate();
  const { request } = useRequest();
  const cookies = new Cookies();
  const [isShow, setsIsShow] = useState(false);
  var videos = document.querySelectorAll('video');
  for (var i = 0; i < videos.length; i++)
    videos[i].addEventListener(
      'play',
      function () {
        pauseAll(this);
      },
      true
    );
  useEffect(() => {
    request('post/getPostCategories', {
      method: 'GET'
    }).then((res) => {
      setGetCategories(res?.data?.result);
    });
    const isFirstLogin = cookies.get('isFirstLogin');
    if (isFirstLogin) {
      console.log(likeCount);
      dispatch({
        type: INTERESTS_MODAL,
        payload: { open: true, isFirstLogin: true }
      });
    }
    if (cookies.get('token')) {
      setUserToStorage(cookies.get('token'));
    }
  }, []);

  function pauseAll(elem) {
    for (var i = 0; i < videos.length; i++) {
      //Is this the one we want to play?
      if (videos[i] == elem) continue;
      //Have we already played it && is it already paused?
      if (videos[i].played.length > 0 && !videos[i].paused) {
        // Then pause it now
        videos[i].pause();
      }
    }
  }
  const isShowFunc = (value) => {
    setsIsShow(value);
  };

  useEffect(() => {
    request('post/getFeed', {
      method: 'POST',
      data: {
        categoryId: subCategoryFilter ? subCategoryFilter : categoryFilter,
        take: 20,
        skip: 0
      }
    }).then(async (res) => {
      setGetFeed(res?.data?.result?.items);
      setHasNext(res?.data?.result?.hasNextPage);
    });
    if (categoryFilter && !subCategoryFilter) {
      request('post/getPostCategories', {
        method: 'GET',
        params: {
          categoryId: categoryFilter
        }
      }).then((res) => {
        console.log(res.data);
        if (res.data.result.length > 0) {
          setSubCategories({ open: true, items: res.data.result });
        }
      });
    }
    if (subCategoryFilter) {
      request('post/getPostCategories', {
        method: 'GET',
        params: {
          categoryId: subCategoryFilter
        }
      }).then((res) => {
        console.log(res.data);
        if (res.data.result.length > 0) {
          setSubCategories({ open: true, items: res.data.result });
        }
      });
    }
  }, [categoryFilter, openModal, subCategoryFilter]);
  useEffect(() => {
    request('post/getFeed', {
      method: 'POST',
      body: {
        categoryId: categoryFilter ? categoryFilter : null,
        take: 20,
        skip: page * 20
      }
    }).then(async (res) => {
      // if(page < res.totalPages){
      //   setPage(page + 1)
      // }
      // if(res?.data?.result?.hasNextPage){
      setGetFeed([...getFeed.concat(res?.data?.result?.items)]);
      // }

      setHasNext(res?.data?.result?.hasNextPage);
    });
  }, [page, openModal]);

  const fetchNewFeed = async () => {
    if (hasNext) {
      setPage(page + 1);
    }
  };

  const likeButton = async (id) => {
    console.log('id', id);
    await request('post/likeOrUnlikePost', {
      method: 'POST',
      params: {
        postId: id
      }
    }).then(async (res) => {
      console.log(res);
      await request('post/getPostLikes', {
        method: 'GET',
        params: {
          postId: id
        }
      }).then((count) => {
        console.log('count', count);
        setGetFeed([
          ...getFeed.map((feed) => {
            if (feed.id === id) {
              setLikeCount(count?.data?.result?.length);

              return {
                ...feed,
                likeCount: count?.data?.result?.length,
                amILiked: count?.data?.result.find((l) => l.amILiked == true) ? true : false
              };
              //console.log("feed.likeCount",feed.likeCount)
            } else {
              return feed;
            }
          })
        ]);
      });
      //setLike(`${Math.floor(Math.random() * 100)}`);
    });
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  const slickSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    nextArrow: <></>,
    prevArrow: <></>,
    slidesToShow: 7,
    slidesToScroll: 7,
    responsive: [
      {
        breakpoint: 1480,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <section className="main-content">
      <div className="container">
        {interestsModal.open && <InterestsModalWithImg />}
        <div className="mainpage-green">
          <div className="mainpage-green-text">HEY Ana Sayfa</div>
          <div className="mainpage-green-container">
            {!subCategories.open && (
              <div onClick={() => setOpenModal(true)} className="mainpage-green-container-card">
                <div className="mainpage-green-container-card-border">
                  <BsPlusLg size={40} color={'green'} />
                </div>
                <span>Gönderi Paylaş</span>
              </div>
            )}

            <Slider className="mainpage-green-container-slick" {...slickSettings}>
              {subCategories.open && (
                <div
                  onClick={() => {
                    setSubCategories({ open: false, items: [] });
                    setSubCategoryFilter(null);
                    setCategoryFilter(null);
                  }}
                  className="mainpage-green-container-card">
                  <div className="mainpage-green-container-card-border">
                    <MdOutlineArrowBack size={50} color={'green'} />
                  </div>
                  <span>Ana Kategorilere Dön</span>
                </div>
              )}
              {getCategories && subCategories.open
                ? subCategories.items.map((categories, index) => (
                    <div
                      onClick={() => setSubCategoryFilter(categories.id)}
                      key={index}
                      className={`mainpage-green-container-card ${
                        categories.id == subCategoryFilter ? 'active' : ''
                      }`}>
                      <div className="mainpage-green-container-card-border">
                        <img src={categories.icon} alt="" />
                      </div>
                      <span>{categories.title}</span>
                    </div>
                  ))
                : getCategories.map((categories, index) => (
                    <div
                      onClick={() => setCategoryFilter(categories.id)}
                      key={index}
                      className={`mainpage-green-container-card ${
                        categories.id == categoryFilter ? 'active' : ''
                      }`}>
                      <div className="mainpage-green-container-card-border">
                        <img src={categories.icon} alt="" />
                      </div>
                      <span>{categories.title}</span>
                    </div>
                  ))}
            </Slider>
          </div>
        </div>
        <div className="mainpage-cardContainer">
          <InfinitScroll
            style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              justifyContent: 'center'
            }}
            dataLength={getFeed.length}
            next={fetchNewFeed}
            hasMore={hasNext}
            //loader={<h4>Loading ... </h4>}
          >
            {getFeed &&
              //getFeed?.sort((a,b) => b.id - a.id)?.map((feed, index) => (
              getFeed
                ?.sort((a, b) => b.id - a.id)
                ?.map((feed, index) => (
                  <div key={index} id="cardRender" className="mainpage-cardContainer-card">
                    {feed?.resources?.length > 1 ? (
                      <Slider {...settings}>
                        {feed?.resources?.map((fd, i) => {
                          return fd.url.split('.').at(-1) == 'avi' ? (
                            <Video
                              key={i}
                              source={fd.url}
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`/detail/${feed.id}`);
                              }}
                            />
                          ) : (
                            <img
                              key={i}
                              onClick={() => navigate(`/detail/${feed.id}`)}
                              className="mainpage-cardContainer-card-image"
                              src={fd?.url}
                              alt=""
                            />
                          );
                        })}
                      </Slider>
                    ) : feed?.resources[0]?.url?.split('.')?.at(-1) == 'avi' ? (
                      <Video
                        source={feed?.resources[0]?.url}
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(`/detail/${feed.id}`);
                        }}
                      />
                    ) : (
                      <img
                        onClick={() => navigate(`/detail/${feed.id}`)}
                        className="mainpage-cardContainer-card-image"
                        src={feed?.resources[0]?.url}
                        alt=""
                      />
                    )}

                    <div className="mainpage-cardContainer-card-dateLikeComment">
                      <div className="mainpage-cardContainer-card-dateLikeComment-left">
                        <img src={images.iconClock} alt="" />
                        <span>{feed?.createdDate}</span>
                      </div>
                      <div className="mainpage-cardContainer-card-dateLikeComment-right">
                        <div onClick={() => likeButton(feed.id)}>
                          {/* <img src={images.iconFavorite} alt="" /> */}
                          {feed?.amILiked ? (
                            <AiFillHeart
                              className="mainpage-cardContainer-card-dateLikeComment-right-heart"
                              size={16}
                            />
                          ) : (
                            <AiOutlineHeart
                              className="mainpage-cardContainer-card-dateLikeComment-right-heart"
                              size={16}
                            />
                          )}
                          <span>{feed?.likeCount} Beğeni</span>
                        </div>
                        <div>
                          <img src={images.iconComment} alt="" />
                          <span>{feed?.commentCount} Yorum</span>
                        </div>
                      </div>
                    </div>
                    <div className="mainpage-cardContainer-card-title">
                      <h1>{feed?.title}</h1>
                      <div className="mainpage-cardContainer-card-title-body">
                        {feed?.profilePhoto && (
                          <img src={feed?.profilePhoto ? feed?.profilePhoto : ''} alt="" />
                        )}
                        <span>{feed?.owner ? feed?.owner : ''}</span>
                      </div>
                      <div className="mainpage-cardContainer-card-title-footer">
                        {feed?.category?.title}
                      </div>
                      <div
                        style={{ marginTop: '3px' }}
                        className="mainpage-cardContainer-card-title-footer">
                        <h3>
                          {feed?.category?.parentCategory ? feed?.category?.parentCategory : ''}
                        </h3>
                      </div>
                    </div>
                  </div>
                ))}
          </InfinitScroll>
          {(categoryFilter || subCategoryFilter) && getFeed.length < 1 && (
            <div className="mainpage-cardContainer-emptyPostTitle">
              Bu Kategoride Henüz Gösterilecek Post Bulunmamaktadır
            </div>
          )}
        </div>
        {openModal && <CreatePostModal setOpenModal={setOpenModal} />}
      </div>
      <Undertaking isShowFunc={isShowFunc} isShow={isShow} />
    </section>
  );
};

export default Home;
